import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

/**
 * Safely initializes Firebase Messaging with environment checks.
 * Returns null if messaging is unsupported (e.g., in emulators or missing browser APIs).
 */
const initializeMessaging = async () => {
  try {
    // Check if Firebase Messaging is supported in this environment
    const isMessagingSupported = await isSupported();
    
    if (!isMessagingSupported) {
      console.warn("Firebase Messaging not supported in this environment");
      return null;
    }

    return getMessaging(app);
  } catch (error) {
    console.error("Failed to initialize Firebase Messaging:", error);
    return null;
  }
};

// Initialize messaging asynchronously to avoid blocking the main thread
let messaging: ReturnType<typeof getMessaging> | null = null;
initializeMessaging().then((initializedMessaging) => {
  messaging = initializedMessaging;
});

/**
 * Helper function to get messaging instance.
 * Returns null if messaging isn't available.
 */
const getFirebaseMessaging = () => messaging;

export { messaging, getFirebaseMessaging };
/*import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
export const getFirebaseMessaging = () => messaging;*/